module.exports = __webpack_public_path__ + "img/9791189273149.50c76fd2.jpg";